'use client'

import { navPathTypes } from "@/type/nav_types";
import customAlert from "@/util/customAlert";
import { useTranslations } from "next-intl";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";
interface navTypes {
    click: boolean,
    movePage: (path: string) => void
}
export const NavContext = createContext<navTypes>({ click: false, movePage: (path: string) => { } })
export const useNav = ()=> useContext(NavContext)
export default function NavProvider({ children }: { children: ReactNode }) {
    const [click, setClick] = useState<boolean>(false)

    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const a = useTranslations("Sentence")

    async function movePage(rawPath: string) {        
        if (!rawPath) {
            customAlert(a('ComingSoon'), "warning");
            return;
        }
        setClick(true)

        // 현재 URL(쿼리 포함)
        const current = `${pathname}${searchParams?.toString() ? `?${searchParams}` : ""}`;

        // 안전하게 캐시버스터 추가 (이미 ?가 있어도 자동 처리)
        const addCacheBuster = (url: string) => {
            // 절대 URL이 아니면 origin 붙여서 URL 객체 생성
            const u = new URL(url, window.location.origin);
            u.searchParams.set("_", Date.now().toString());
            // origin 제외한 경로만 리턴
            return u.pathname + (u.search ? u.search : "");
        };

        // 같은 경로라도 '뒤로가기 기록'을 남기려면 replace가 아니라 push 사용
        if (rawPath === current) {
            router.push(addCacheBuster(rawPath));
            // location.reload()
        } else {
            router.push(rawPath);
        }
    }

    useEffect(()=> {
        setClick(false)
    }, [pathname, searchParams])

    const contextValue = {
        click,
        movePage
    }
    return (
        <NavContext.Provider value={contextValue}>{children}</NavContext.Provider>
    )
}